/* Beylora Build a Set engine (2026-08-10).
   Runs ONLY on the build-a-set page (its section includes this file).
   Reads the section's JSON data blob (products, variants, media, pairing map),
   drives the 3-step flow, and adds BOTH pieces in one cart call.
   Gap features: forward-locked steps, prefill deep links, band-first entry,
   metal + size sync defaults, mismatch note, pairing sort, shape filters,
   share-the-set links, localStorage resume, GA4 events, partner-code note. */

(async function () {
  const root = document.querySelector('[data-set-builder]');
  if (!root) return;
  let DATA;
  const status = document.createElement('p');
  status.setAttribute('role', 'status');
  try {
    DATA = JSON.parse(document.getElementById('SetBuilderData').textContent);
    if (!Array.isArray(DATA.rings) || !Array.isArray(DATA.bands)) throw new Error('Invalid catalog data');
    // Load every native collection page before resolving selections or deep links.
    if (DATA.pagination?.pages > 1) {
      status.textContent = 'Loading rings...'; root.prepend(status);
      root.setAttribute('aria-busy', 'true');
      const all = new Map(DATA.rings.map(p => [p.handle, p]));
      for (let page = 1; page <= DATA.pagination.pages; page++) {
        if (page === DATA.pagination.page) continue;
        const url = new URL(location.href); url.searchParams.set(DATA.pagination.param || 'page', String(page)); url.searchParams.set('section_id', DATA.pagination.section);
        const response = await fetch(url, {signal: AbortSignal.timeout(15000)});
        if (!response.ok) throw new Error('Catalog page unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = JSON.parse(doc.getElementById('SetBuilderData').textContent);
        if (next.pagination.page !== page || next.pagination.total !== DATA.pagination.total) throw new Error('Catalog changed during loading');
        next.rings.forEach(p => all.set(p.handle, p));
      }
      if (all.size !== DATA.pagination.total) throw new Error('Incomplete catalog');
      DATA.rings = [...all.values()];
    }
    // The band collection is paginated separately from engagement rings.
    // A second direct ?page URL can otherwise hide every band in this step.
    const bandNode = document.getElementById('SetBuilderBandData');
    if (!bandNode) throw new Error('Band catalog data missing');
    const bandData = JSON.parse(bandNode.textContent);
    if (!Array.isArray(bandData.bands) || !bandData.pagination) throw new Error('Invalid band catalog');
    const allBands = new Map(bandData.bands.map(p => [p.handle, p]));
    for (let page = 1; page <= bandData.pagination.pages; page++) {
      if (page === bandData.pagination.page) continue;
      status.textContent = 'Loading wedding bands...'; if (!status.isConnected) root.prepend(status);
      root.setAttribute('aria-busy', 'true');
      const url = new URL(location.href);
      url.searchParams.set(bandData.pagination.param || 'page', String(page));
      url.searchParams.set('section_id', bandData.pagination.section);
      const response = await fetch(url, { signal: AbortSignal.timeout(15000) });
      if (!response.ok) throw new Error('Band catalog page unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextNode = doc.getElementById('SetBuilderBandData');
      if (!nextNode) throw new Error('Band catalog page missing');
      const next = JSON.parse(nextNode.textContent);
      if (next.pagination.page !== page || next.pagination.total !== bandData.pagination.total) throw new Error('Band catalog changed during loading');
      next.bands.forEach(p => allBands.set(p.handle, p));
    }
    if (allBands.size !== bandData.pagination.total) throw new Error('Incomplete band catalog');
    DATA.bands = [...allBands.values()];
    // A profile can arrive before its variant-image bindings during an import.
    // Do not label a fallback image as the exact selected source photograph.
    if (DATA.rings.some(p => p.sourcePhotoProfiles && p.variants.some(v => !v.photoHero))) throw new Error('Catalog photo assignment incomplete');
    status.remove(); root.removeAttribute('aria-busy');
  } catch (error) {
    status.textContent = 'The set catalog could not load. Please reload this page to try again.';
    if (!status.isConnected) root.prepend(status);
    root.removeAttribute('aria-busy');
    root.dataset.catalogReady = 'error'; root.querySelectorAll('button').forEach(b => { b.disabled = true; }); return;
  }
  root.dataset.catalogCount = String(DATA.rings.length);
  root.dataset.bandCount = String(DATA.bands.length);
  root.dataset.catalogReady = 'true';

  const PAIRS = JSON.parse(document.getElementById('SetBuilderPairs').textContent);
  const METALS = [
    ['14k White Gold', 0, 'white', '14kw'],
    ['14k Yellow Gold', 0, 'yellow', '14ky'],
    ['18k Yellow Gold', 500, 'yellow', '18ky'],
    ['18k White Gold', 500, 'white', '18kw'],
    ['Platinum', 700, 'white', 'plat'],
    ['18k Yellow Gold and Platinum', 0, 'yellow', '18ygpt'],
  ];
  const BAND_ROSE = ['14k Rose Gold', 0, 'rose', '14kr'];
  const BAND_METALS = [...METALS, BAND_ROSE];
  const bandMetalByCode = (c) => BAND_METALS.find((m) => m[3] === c) || METALS[0];
  const SIZES = ['3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10'];
  const CARATS = ['1', '1.5', '2', '2.5', '3', '3.5', '4', '5'];
  /* rings open on 1 ct (2026-10-22); a ring without 1 ct variants opens on its lowest carat */
  const firstCarat = (p) => CARATS.find((c) => p && p.variants.some((v) => v.carat === c)) || CARATS[0];
  const money = (n) => '$' + Math.round(n).toLocaleString('en-US');
  const $ = (sel) => root.querySelector(sel);
  const $$ = (sel) => [...root.querySelectorAll(sel)];
  const byHandle = (list, h) => list.find((p) => p.handle === h) || null;
  const metalByCode = (c) => METALS.find((m) => m[3] === c) || METALS[0];

  const st = {
    ring: null, carat: CARATS[0], ringMetal: METALS[0], ringSize: null,
    band: null, bandMetal: METALS[0], bandMetalTouched: false, bandSize: null, bandSizeTouched: false,
    shapeFilter: 'All', bandTypeFilter: 'All',
    ringShown: 12, /* rings on screen; the list starts at one page and grows by Show more (2026-10-23) */
    sortBy: 'curated', /* never price by default: a premium grid leads with curation */
    /* grid metal view (Joe 2026-08-19): tiles open in white gold; the toggle
       flips every tile to yellow gold and presets the matching 14k metal */
    metalView: 'white',
  };
  const viewMetal = () => metalByCode(st.metalView === 'yellow' ? '14ky' : '14kw');

  /* ---------- helpers ---------- */
  function sourcePhoto(p, metal, carat = firstCarat(p)) {
    if (!p || !p.sourceKey) return null;
    const v = p.variants.find(v => v.carat === String(carat) && v.metal === metal[0]);
    const exact = p.sourcePhotoProfiles?.profiles?.[v?.sku];
    const reference = p.sourcePhotoProfiles && Object.values(p.sourcePhotoProfiles.profiles).find(photo => Number(photo.carat) === Number(p.sourcePhotoProfiles.reference.carat) && photo.metal.toLowerCase() === metal[0].toLowerCase());
    const profile = exact || reference || p.sourcePhotoProfiles?.reference || p.sourcePreview;
    // A single canonical option can use its verified source preview directly.
    // Never bypass an explicit profile map or qualify a different selection.
    const exactSingle = !p.sourcePhotoProfiles && p.variants.length === 1 && !!v
      && Number(profile?.carat) > 0 && Number(profile.carat) === Number(carat)
      && profile.metal?.toLowerCase() === metal[0].toLowerCase();
    return { ...profile, matched: !!exact || exactSingle, hero: v?.photoHero || p.sourcePreview.hero };
  }
  function photoDescription(photo) {
    return (photo.matched ? 'Photo: ' : 'Reference photo: ') + photo.carat + 'ct in ' + photo.metal + '.';
  }
  const imgFor = (p, metal, kind) => {
    if (p.sourceKey && p.sourcePreview) return sized(sourcePhoto(p, metal).hero, kind === 'thumb' ? 300 : 640);
    const set = metal[2] === 'rose' ? p.rose : (metal[2] === 'yellow' ? p.yellow : p.white);
    const fallback = metal[2] === 'yellow' ? p.white : p.yellow;
    const src = (set && set[kind]) || (p.researchId ? '' : (fallback && fallback[kind])) || '';
    return src;
  };
  /* thumbs bake width=300; serve 2x for retina desktops (persona QA 2026-08-19) */
  const setThumb = (im, src) => {
    im.src = src;
    im.srcset = /width=300/.test(src) ? src + ' 1x, ' + src.replace('width=300', 'width=600') + ' 2x' : '';
  };
  /* The Liquid blob only bakes the 2 ct hero/thumb, so any surface drawing from
     it showed a 2 ct stone next to "5 ct" text (persona QA 2026-08-19: the
     review pane understated the diamond on the screen that closes the sale).
     The live product media has every carat; prefer it, fall back to the blob. */
  function caratArt(kind, w) {
    const p = kind === 'ring' ? st.ring : st.band;
    if (!p) return null;
    if (p.sourceKey) return sized(sourcePhoto(p, st.ringMetal, st.carat).hero, w);
    const list = mediaCache[p.handle];
    if (!list) return null;
    const metal = kind === 'ring' ? st.ringMetal : st.bandMetal;
    const carat = kind === 'ring' ? st.carat : null;
    const m = mediaFor(list, metal, carat).find((x) => x.type !== 'video' && x.img);
    return m ? sized(m.img, w) : null;
  }
  function withCaratArt(kind, el, w) {
    if (!el) return;
    const p = kind === 'ring' ? st.ring : st.band;
    const fallback = p ? imgFor(p, kind === 'ring' ? st.ringMetal : st.bandMetal, w > 320 ? 'hero' : 'thumb') : '';
    const now = caratArt(kind, w);
    el.src = now || fallback;
    if (now || !p) return;
    const want = p.handle + '|' + st.carat + '|' + (kind === 'ring' ? st.ringMetal[0] : st.bandMetal[0]);
    productMedia(p.handle).then(() => {
      const cur = (kind === 'ring' ? st.ring : st.band);
      if (!cur || cur.handle + '|' + st.carat + '|' + (kind === 'ring' ? st.ringMetal[0] : st.bandMetal[0]) !== want) return;
      const src = caratArt(kind, w);
      if (src) el.src = src;
    }).catch(() => {});
  }

  const ringVariant = () => {
    if (!st.ring) return null;
    return st.ring.variants.find((v) => v.carat === st.carat && v.metal === st.ringMetal[0]) || null;
  };
  const bandVariant = () => {
    if (!st.band) return null;
    return st.band.variants.find((v) => v.metal === st.bandMetal[0]) || null;
  };
  const ringPrice = () => { const v = ringVariant(); return v ? v.price : null; };
  const bandPrice = () => { const v = bandVariant(); return v ? v.price : null; };
  const ringCompare = () => { const v = ringVariant(); return v && v.compare > v.price ? v.compare : null; };
  const bandCompare = () => { const v = bandVariant(); return v && v.compare > v.price ? v.compare : null; };
  /* MSRP-struck + sale + percent (numbers only, safe to template) */
  const priceHTML = (p, m) => {
    /* refinement pass 2026-08-23: live price leads; was-price + offer follow quietly */
    if (m && m > p) {
      const off = Math.round(((m - p) / m) * 100);
      return money(p) + ' <s class="bsb__msrp">' + money(m) + '</s><span class="bsb__off">' + off + '% off</span>';
    }
    return money(p);
  };

  /* ---------- full media gallery (photos + 360 videos, PDP filter semantics) ---------- */
  const mediaCache = {};
  async function productMedia(handle) {
    if (mediaCache[handle]) return mediaCache[handle];
    const j = await (await fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })).json();
    /* price-truth guard (2026-08-10): the page's baked data blob can be a
       stale cache snapshot; the live product.js just fetched is the truth.
       Patch this product's in-memory prices and re-render so configure lines,
       chips, and totals always match what checkout will charge. */
    const dp = [...DATA.rings, ...DATA.bands].find((p) => p.handle === handle);
    if (dp && Array.isArray(j.variants)) {
      let changed = false;
      for (const v of j.variants) {
        const dv = dp.variants.find((x) => x.id === v.id);
        if (!dv) continue;
        const price = Math.round(v.price / 100);
        const compare = v.compare_at_price ? Math.round(v.compare_at_price / 100) : 0;
        if (dv.price !== price || dv.compare !== compare) { dv.price = price; dv.compare = compare; changed = true; }
      }
      if (changed) window.setTimeout(render, 0);
    }
    mediaCache[handle] = (j.media || []).map((m) => ({
      id: String(m.id),
      alt: m.alt || '',
      type: m.media_type,
      img: (m.preview_image && m.preview_image.src) || m.src || '',
      /* Shopify transcodes each upload to several renditions and lists 480p
         first; taking [0] served a soft 480p spin on a $2,500 ring (persona QA
         2026-08-19). Take the tallest mp4 available. */
      mp4: ((m.sources || []).filter((s) => /mp4/i.test(s.format || s.mime_type || ''))
             .sort((a, b) => (b.height || 0) - (a.height || 0))[0] || {}).url || null,
    }));
    return mediaCache[handle];
  }
  function mediaFor(list, metal, carat) {
    const m = mediaForExact(list, metal, carat);
    /* no 1 ct or 1.5 ct photos yet: show the ring's 2 ct set rather than an empty gallery */
    if (!m.length && carat && parseFloat(carat) < 2) return mediaForExact(list, metal, '2');
    return m;
  }
  function mediaForExact(list, metal, carat) {
    const yellow = metal[2] === 'yellow';
    return list.filter((m) => {
      const alt = m.alt || '';
      if (/Product Image \d+/i.test(alt)) return false;
      const isY = /yellow gold/i.test(alt), isW = /white gold/i.test(alt), isR = /rose gold/i.test(alt);
      const metalOk = metal[2] === 'rose' ? isR : (yellow ? isY : (isW || (!isY && !isW && !isR)));
      if (!metalOk) return false;
      const cms = alt.match(/([\d.]+)\s*ct\b/gi);
      if (!cms || !carat) return true;
      return cms.some((t) => parseFloat(t) === parseFloat(carat));
    });
  }
  const sized = (url, w) => {
    if (!url) return url;
    const imageUrl = new URL(url, location.origin);
    imageUrl.searchParams.set('width', String(w));
    return imageUrl.href;
  };
  const galleryKeys = { ring: '', band: '' };
  function buildGallery(kind) {
    const p = kind === 'ring' ? st.ring : st.band;
    if (!p) return;
    const metal = kind === 'ring' ? st.ringMetal : st.bandMetal;
    const carat = kind === 'ring' ? st.carat : null;
    const key = p.handle + '|' + metal[0] + '|' + (carat || '');
    if (galleryKeys[kind] === key) return;
    galleryKeys[kind] = key;
    productMedia(p.handle).then((all) => {
      if (galleryKeys[kind] !== key) return; /* selection moved on while fetching */
      const wrap = root.querySelector('[data-gallery="' + kind + '"]');
      const track = wrap.querySelector('[data-gallery-track]');
      const dots = wrap.querySelector('[data-gallery-dots]');
      const profile = sourcePhoto(p, metal, carat);
      const list = profile?.media_ids ? profile.media_ids.map(id => all.find(m => m.id === String(id))).filter(Boolean) : p.sourceKey ? all : mediaFor(all, metal, carat);
      if (!list.length) return; /* keep the hero fallback slide */
      track.innerHTML = '';
      dots.innerHTML = '';
      list.forEach((m, i) => {
        const slide = document.createElement('div');
        slide.className = 'bsb__gslide';
        if (m.type === 'video' && m.mp4) {
          const v = document.createElement('video');
          v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.preload = 'metadata';
          v.src = m.mp4; if (m.img) v.poster = sized(m.img, 640);
          v.setAttribute('aria-label', m.alt || 'Video');
          slide.appendChild(v);
        } else {
          const im = document.createElement('img');
          im.loading = i === 0 ? 'eager' : 'lazy';
          im.src = sized(m.img, 640); im.alt = m.alt || p.name;
          im.width = 640; im.height = 640;
          slide.appendChild(im);
        }
        track.appendChild(slide);
        const d = document.createElement('button');
        d.type = 'button'; d.className = 'bsb__gdot' + (i === 0 ? ' is-on' : '');
        d.setAttribute('aria-label', 'Photo ' + (i + 1));
        d.onclick = () => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        dots.appendChild(d);
      });
      track.scrollTo({ left: 0 });
      syncGallery(track, dots);
    }).catch(() => { galleryKeys[kind] = ''; /* failed fetch must not pin the
      gallery to the fallback slide forever; next render retries */ });
  }
  function syncGallery(track, dots) {
    const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    [...dots.children].forEach((d, j) => d.classList.toggle('is-on', j === i));
    [...track.querySelectorAll('video')].forEach((v, _, arr) => {
      const r = v.getBoundingClientRect();
      const on = r.width > 0 && r.right > 40 && r.left < (window.innerWidth - 40);
      if (on && v.paused) { const pr = v.play(); if (pr && pr.catch) pr.catch(() => {}); }
      else if (!on && !v.paused) v.pause();
    });
  }
  root.querySelectorAll('[data-gallery]').forEach((wrap) => {
    const track = wrap.querySelector('[data-gallery-track]');
    const dots = wrap.querySelector('[data-gallery-dots]');
    let raf = 0;
    track.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; syncGallery(track, dots); }); }, { passive: true });
    wrap.querySelector('[data-gallery-prev]').onclick = () => track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    wrap.querySelector('[data-gallery-next]').onclick = () => track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
  });
  const ringDone = () => !!(st.ring && st.carat && st.ringSize && ringVariant());
  const bandDone = () => !!(st.band && st.bandSize && bandVariant());

  const track = (event, extra) => {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event }, extra || {})); } catch (e) {}
  };

  /* No cross-visit resume (Joe ruling 2026-08-11): the builder always opens
     fresh at Choose Your Ring. Only an explicit link (share / PDP entry strip)
     may pre-select, via URL params. */
  const save = () => { try { localStorage.removeItem('beylora_set_builder'); } catch (e) {} };
  const shareParams = () => {
    const q = new URLSearchParams();
    if (st.ring) { q.set('ring', st.ring.handle); q.set('carat', st.carat); q.set('rm', st.ringMetal[3]); if (st.ringSize) q.set('rs', st.ringSize); }
    if (st.band) { q.set('band', st.band.handle); q.set('bm', st.bandMetal[3]); if (st.bandSize) q.set('bs', st.bandSize); }
    return q.toString();
  };

  function applyState(src, fromLink) {
    if (!src) return false;
    let any = false;
    if (src.ring && byHandle(DATA.rings, src.ring)) { st.ring = byHandle(DATA.rings, src.ring); any = true; }
    if (src.carat && CARATS.includes(String(src.carat))) st.carat = String(src.carat);
    if (src.rm) st.ringMetal = metalByCode(src.rm);
    if (src.rs && SIZES.includes(String(src.rs))) st.ringSize = String(src.rs);
    if (src.band && byHandle(DATA.bands, src.band)) { st.band = byHandle(DATA.bands, src.band); any = true; }
    if (src.bm) { st.bandMetal = bandMetalByCode(src.bm); st.bandMetalTouched = true; }
    if (src.bs && SIZES.includes(String(src.bs))) { st.bandSize = String(src.bs); st.bandSizeTouched = true; }
    if (fromLink) { st.bandMetalTouched = true; st.bandSizeTouched = true; }
    return any;
  }

  /* ---------- partner-code note (best effort, silent when absent) ---------- */
  /* Off until Joe activates the partner program; flip to true then, together
     with VENDOR_LINKS_ACTIVE in layout/theme.liquid. */
  const PARTNER_CODES_ACTIVE = false;
  function partnerCodeActive() {
    if (!PARTNER_CODES_ACTIVE) return false;
    /* link-visit evidence only (verified live 2026-08-19: the tracker writes
       ref + gfp_* keys on tracked link visits and nothing on cold ones; a bare
       discount_code cookie can come from ANY discount link and must not claim
       a partner saving) */
    try {
      if (/(^|;\s*)(ref|goaffpro_ref|gfp_ref_expires)=/.test(document.cookie)) return true;
      if (localStorage.getItem('ref') || localStorage.getItem('gfp_ref_expires')) return true;
    } catch (e) {}
    return false;
  }

  /* ---------- grids ---------- */
  function ringGrid() {
    const grid = $('[data-ring-grid]');
    grid.innerHTML = '';
    // 2026-10-06: same order and drawings as the Engagement Rings shape row
    const ORDER = ['Round', 'Oval', 'Emerald', 'Cushion', 'Elongated Cushion', 'Old Mine', 'Pear', 'Marquise', 'Radiant', 'Princess', 'Asscher', 'Heart'];
    const have = new Set(DATA.rings.map((r) => r.shape).filter(Boolean));
    const shapes = ['All', ...ORDER.filter((s) => have.has(s)), ...[...have].filter((s) => !ORDER.includes(s))];
    const fwrap = $('[data-shape-filters]');
    fwrap.innerHTML = '';
    shapes.forEach((s) => {
      const b = document.createElement('button');
      b.type = 'button';
      const art = document.querySelector(`template[data-shape-art="${s}"]`);
      b.className = 'bsb-filter' + (art ? ' bsb-filter--shape' : '') + (st.shapeFilter === s ? ' is-on' : '');
      b.setAttribute('aria-pressed', st.shapeFilter === s ? 'true' : 'false');
      if (art) {
        const a = document.createElement('span'); a.className = 'bsb-shape-art'; a.appendChild(art.content.cloneNode(true));
        const n = document.createElement('span'); n.className = 'bsb-shape-name'; n.textContent = s === 'All' ? 'All shapes' : s;
        b.append(a, n);
      } else b.textContent = s;
      b.onclick = () => {
        st.shapeFilter = s; st.ringShown = RING_PAGE; ringGrid();
        const on = fwrap.querySelector('.bsb-filter.is-on');
        if (on) on.focus({ preventScroll: true });
      };
      fwrap.appendChild(b);
    });
    let list = DATA.rings.filter((r) => st.shapeFilter === 'All' || r.shape === st.shapeFilter);
    if (st.sortBy === 'price') list = sortByFrom(list);
    /* Build a Set was 59,851 px tall on a phone with every ring listed at once
       (UX audit 2026-10-23, #12): the list starts at one page of rings and
       grows by Show more. Choosing a ring, carat and band work as before. */
    const shown = Math.min(Math.max(st.ringShown, RING_PAGE), list.length);
    list.slice(0, shown).forEach((p, i) => { grid.appendChild(tile(p, true, false, i)); });
    ringMore(list, shown);
  }
  const RING_PAGE = 12; /* first view */
  const RING_MORE = 24; /* each Show more: the full catalog is about 430 rings, so 12 at a time was 35 taps */
  /* count line plus the Show more button under the ring grid (markup lives in the section) */
  function ringMore(list, shown) {
    const wrap = $('[data-ring-more]');
    if (!wrap) return;
    const left = list.length - shown;
    const count = $('[data-ring-count]');
    const btn = $('[data-ring-more-btn]');
    if (count) count.textContent = 'Showing ' + shown + ' of ' + list.length + (st.shapeFilter === 'All' ? ' rings' : ' ' + st.shapeFilter.toLowerCase() + ' rings');
    if (btn) {
      btn.textContent = 'Show ' + Math.min(RING_MORE, left) + ' more';
      btn.onclick = () => {
        const grid = $('[data-ring-grid]');
        const from = shown;
        st.ringShown = Math.min(from + RING_MORE, list.length);
        /* append only the new tiles: the tiles on screen, the scroll position and focus stay put */
        list.slice(from, st.ringShown).forEach((p, i) => { grid.appendChild(tile(p, true, false, from + i)); });
        ringMore(list, st.ringShown);
        const first = grid.querySelectorAll ? grid.querySelectorAll('.bsb-tile')[from] : null;
        if (first && first.focus) first.focus({ preventScroll: true });
        track('set_builder_show_more', { shown: st.ringShown });
      };
    }
    wrap.hidden = list.length <= RING_PAGE;
    if (btn) btn.hidden = left <= 0;
  }
  function bandGrid() {
    const grid = $('[data-band-grid]');
    grid.innerHTML = '';
    const labels = [['All', 'All bands'], ['lab_diamond', 'Lab-grown diamond'], ['plain', 'Plain metal']]
      .filter(([value]) => value === 'All' || DATA.bands.some(p => p.category === value));
    if (!labels.some(([value]) => value === st.bandTypeFilter)) st.bandTypeFilter = 'All';
    const filterWrap = $('[data-band-type-filters]');
    filterWrap.innerHTML = '';
    labels.forEach(([value, label]) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'bsb-filter' + (st.bandTypeFilter === value ? ' is-on' : '');
      button.setAttribute('aria-pressed', st.bandTypeFilter === value ? 'true' : 'false');
      button.textContent = label;
      button.onclick = () => { st.bandTypeFilter = value; bandGrid(); const on = filterWrap.querySelector('.bsb-filter.is-on'); if (on) on.focus({ preventScroll: true }); };
      filterWrap.appendChild(button);
    });
    const visible = DATA.bands.filter(p => st.bandTypeFilter === 'All' || p.category === st.bandTypeFilter);
    const preferred = (st.ring && PAIRS[st.ring.handle]) || [];
    const sorted = [...visible].sort((a, b) => {
      const ai = preferred.indexOf(a.handle), bi = preferred.indexOf(b.handle);
      return (ai < 0 ? 99 : ai) - (bi < 0 ? 99 : bi);
    });
    const ordered = st.sortBy === 'price' ? sortByFrom([...visible]) : sorted;
    ordered.forEach((p, i) => grid.appendChild(tile(p, false, preferred.includes(p.handle), i)));
  }
  const fromPrice = (p) => {
    const white = p.variants.filter((v) => v.metal === '14k White Gold');
    const w = white.length ? white : p.variants;
    return w.reduce((a, v) => Math.min(a, v.price), Infinity);
  };
  const sortByFrom = (list) => list.slice().sort((a, b) => fromPrice(a) - fromPrice(b));

  /* Sort control (Joe 2026-08-20): offered, never the default. */
  function sortControls() {
    $$('[data-sort]').forEach((wrap) => {
      wrap.innerHTML = '';
      [['curated', 'Curated'], ['price', 'Price, low to high']].forEach((pair) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'bsb-sort' + (st.sortBy === pair[0] ? ' is-on' : '');
        b.textContent = pair[1];
        b.setAttribute('aria-pressed', st.sortBy === pair[0] ? 'true' : 'false');
        b.onclick = () => {
          if (st.sortBy === pair[0]) return;
          st.sortBy = pair[0]; st.ringShown = RING_PAGE;
          sortControls(); ringGrid(); bandGrid(); render(); save();
          track('set_builder_sort', { sort: pair[0] });
        };
        wrap.appendChild(b);
      });
    });
  }

  /* ---------- grid metal-view toggle (Joe 2026-08-19) ---------- */
  function metalToggles() {
    $$('[data-metal-view]').forEach((wrap) => {
      wrap.innerHTML = '';
      [['white', 'White gold'], ['yellow', 'Yellow gold']].forEach((pair) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'bsb-mv';
        b.dataset.fam = pair[0];
        const dot = document.createElement('span');
        dot.className = 'bsb-mv-dot bsb-mv-dot--' + pair[0];
        b.appendChild(dot);
        b.appendChild(document.createTextNode(pair[1]));
        b.onclick = () => setMetalView(pair[0]);
        wrap.appendChild(b);
      });
    });
    syncMetalToggles();
  }
  function syncMetalToggles() {
    $$('[data-metal-view] .bsb-mv').forEach((b) => {
      const on = b.dataset.fam === st.metalView;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function setMetalView(fam) {
    if (st.metalView === fam) return;
    st.metalView = fam;
    /* view-only: the toggle repaints tiles and NEVER rewrites an already-made
       selection (persona QA 2026-08-19: it silently flipped a configured
       white-gold ring to yellow). The metal preset happens at TILE CLICK,
       where the click itself says "this ring, in this metal". */
    syncMetalToggles();
    ringGrid();
    bandGrid();
    render(); save();
    track('set_builder_metal_view', { view: fam });
  }

  /* input shield: stray taps from a rapid multi-tap on a forward button land
     on the just-revealed grid and silently pick a tile (persona QA 2026-08-19,
     Pixel triple-tap repro); ignore tile clicks right after a view switch */
  let viewSwitchedAt = 0;
  function tile(p, isRing, paired, idx) {
    const b = document.createElement('button');
    b.className = 'bsb-tile';
    b.dataset.productHandle = p.handle;
    b.type = 'button';
    const whites = p.variants.filter((v) => v.metal === '14k White Gold');
    const fromV = (whites.length ? whites : p.variants).reduce((a, v) => (a && a.price <= v.price ? a : v), null);
    const wantedMetal = viewMetal();
    const metal = isRing || p.variants.some(v => v.metal === wantedMetal[0]) ? wantedMetal : (BAND_METALS.find(m => m[0] === p.variants[0]?.metal) || wantedMetal);
    if (paired) { const t = document.createElement('span'); t.className = 'bsb-pairtag'; t.textContent = 'Pairs beautifully'; b.appendChild(t); }
    const im = document.createElement('img');
    /* perf (2026-08-10 Lighthouse): the first row must not lazy-load - the
       top-left tile IS the page's largest paint on phones */
    im.loading = idx < 4 ? 'eager' : 'lazy';
    if (idx === 0) im.setAttribute('fetchpriority', 'high');
    im.decoding = 'async';
    im.width = 300; im.height = 300;
    setThumb(im, imgFor(p, metal, 'thumb')); im.alt = p.name; b.appendChild(im);
    if (!isRing && metal[0] !== wantedMetal[0]) { const note = document.createElement('span'); note.className = 'bsb-source-caption'; note.textContent = 'Shown in ' + metal[0]; b.appendChild(note); }
    const tn = document.createElement('span'); tn.className = 'bsb-tn'; tn.textContent = p.name; b.appendChild(tn);
    /* Card price system (refinement pass 2026-08-23, supersedes the 2026-08-10
       struck-first order): the live "From" price leads, the was-price and offer
       follow as one quiet group, matching the collection cards. */
    const tp = document.createElement('span'); tp.className = 'bsb-tp';
    if (fromV.compare > fromV.price) {
      tp.appendChild(document.createTextNode('From ' + money(fromV.price) + ' '));
      const was = document.createElement('span'); was.className = 'bsb-twas';
      const s = document.createElement('s'); s.textContent = money(fromV.compare); was.appendChild(s);
      const off = document.createElement('span'); off.className = 'bsb-toff';
      off.textContent = Math.round(((fromV.compare - fromV.price) / fromV.compare) * 100) + '% off';
      was.appendChild(off);
      tp.appendChild(was);
    } else {
      tp.textContent = 'From ' + money(fromV.price);
    }
    b.appendChild(tp);
    if (p.sourceKey) { const caption = document.createElement('span'); caption.className = 'bsb-source-caption'; caption.textContent = photoDescription(sourcePhoto(p, metal)); b.appendChild(caption); }

    b.onclick = () => {
      if (Date.now() - viewSwitchedAt < 400) return;
      if (isRing) {
        st.ring = p;
        /* clicking a tile from a toggled grid presets that family's 14k metal
           (Joe ruling 2026-08-19); a matching family keeps any finer pick */
        if (viewMetal()[2] !== st.ringMetal[2]) {
          st.ringMetal = viewMetal();
          if (!st.bandMetalTouched) st.bandMetal = st.ringMetal;
        }
        $('[data-ring-choose]').hidden = true;
        $('[data-ring-configure]').hidden = false;
        track('set_builder_ring_selected', { ring: p.handle });
      } else {
        st.band = p;
        if (!st.bandMetalTouched) st.bandMetal = viewMetal()[2] !== st.ringMetal[2] ? viewMetal() : st.ringMetal; /* metal sync default, view-aware */
        if (!st.bandSizeTouched && st.ringSize) st.bandSize = st.ringSize; /* size sync default */
        $('[data-band-choose]').hidden = true;
        $('[data-band-configure]').hidden = false;
        track('set_builder_band_selected', { band: p.handle });
      }
      render(); save();

      /* the grid this tile lived in is now hidden; land keyboard focus on the
         configure pane's product name (tabindex=-1) */
      const pn = $(isRing ? '[data-ring-name]' : '[data-band-name]');
      revealConfiguration(pn);
    };
    return b;
  }

  /* ---------- chips ---------- */
  const fmtDelta = (d) => (d === 0 ? 'Same price' : (d > 0 ? '+' : '-') + money(Math.abs(d)));
  function chips(el, items, mk, onPick, selIdx) {
    el.innerHTML = '';
    const selPrice = mk !== 'size' && selIdx >= 0 && items[selIdx] ? items[selIdx][1] : null;
    items.forEach((it, i) => {
      const c = document.createElement('button');
      c.type = 'button';
      c.className = 'bsb-chip' + (mk === 'size' ? ' bsb-chip--sz' : '') + (i === selIdx ? ' is-sel' : '');
      c.setAttribute('aria-pressed', i === selIdx ? 'true' : 'false');
      if (mk === 'size') {
        c.textContent = it;
      } else {
        /* delta-plus-absolute (Joe ruling 2026-08-10): the change leads, the
           full resulting price sits beneath. Numbers only: safe to template. */
        const label = mk === 'carat' ? it[0] + 'ct' : it[0];
        const lead = i === selIdx ? 'Selected' : selPrice != null ? fmtDelta(it[1] - selPrice) : money(it[1]);
        c.innerHTML = label + '<small class="bsb-delta">' + lead + '</small><small class="bsb-abs">' + money(it[1]) + '</small>';
      }
      c.tabIndex = (selIdx >= 0 ? i === selIdx : i === 0) ? 0 : -1;
      c.onclick = () => {
        onPick(it, i); render(); save();
        /* render() rebuilt this row and destroyed the focused node; hand
           focus to the now-selected chip so keyboard users keep their place
           (persona QA 2026-08-19: focus fell to BODY on every chip press) */
        const sel = el.querySelector('.bsb-chip.is-sel');
        if (sel) sel.focus({ preventScroll: true });
      };
      el.appendChild(c);
    });
    /* arrows move within the group, Tab leaves it: walking 19 size chips was
       a third of a keyboard user's whole journey (persona QA 2026-08-19).
       Movement only; Enter/Space still does the choosing. */
    el.onkeydown = (e) => {
      const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      const step = keys[e.key];
      const items = [...el.querySelectorAll('.bsb-chip')];
      if (!items.length) return;
      let next = null;
      if (step) next = items[(items.indexOf(document.activeElement) + step + items.length) % items.length];
      else if (e.key === 'Home') next = items[0];
      else if (e.key === 'End') next = items[items.length - 1];
      if (!next) return;
      e.preventDefault();
      items.forEach((c) => { c.tabIndex = -1; });
      next.tabIndex = 0;
      next.focus();
    };
  }

  /* ---------- steps ---------- */
  function go(n, fromHistory) {
    if (n === 2 && !ringDone()) return;
    if (n === 3 && !(ringDone() && bandDone())) return;
    /* browser Back must step back, not eject the whole build (persona QA
       2026-08-19); each user-driven step change becomes a history entry */
    if (!fromHistory) { try { history.pushState({ bsbStep: n }, '', location.href); } catch (e) {} }
    viewSwitchedAt = Date.now();
    $$('.bsb-pane').forEach((p, i) => p.classList.toggle('is-on', i === n - 1));
    $$('.bsb-step').forEach((s, i) => { s.classList.toggle('is-on', i === n - 1); s.classList.toggle('is-done', i < n - 1); });
    if (n === 2) {
      withCaratArt('ring', $('[data-pairstrip-img]'), 300);
      $('[data-pairstrip-name]').textContent = st.ring.name + ' · ' + st.carat + 'ct · ' + st.ringMetal[0] + ' · size ' + st.ringSize;
      if (!st.band) { $('[data-band-choose]').hidden = false; $('[data-band-configure]').hidden = true; }
      bandGrid();
    }
    if (n === 3) review();
    /* step advance left focus on BODY, so the next Tab landed on
       an off-page link (persona QA 2026-08-19, keyboard user) */
    render(); /* re-derive the tray CTA for the NEW pane (persona QA 2026-08-19:
       share links landed on the set with a stale "Choose the band" button) */
    track('set_builder_step', { step: n });
    focusPane(n);
  }
  window.addEventListener('popstate', (e) => {
    const n = e.state && e.state.bsbStep;
    if (n) go(n, true);
  });
  $$('.bsb-step').forEach((s) => { s.onclick = () => go(Number(s.dataset.goto)); });
  $('[data-to-band]').onclick = () => go(2);
  $('[data-to-review]').onclick = () => go(3);
  $$('[data-goto-back]').forEach((b) => { b.onclick = () => go(Number(b.dataset.gotoBack)); });
  $$('[data-change]').forEach((btn) => {
    btn.onclick = () => {
      viewSwitchedAt = Date.now();
      if (btn.dataset.change === 'ring') { $('[data-ring-choose]').hidden = false; $('[data-ring-configure]').hidden = true; }
      else { $('[data-band-choose]').hidden = false; $('[data-band-configure]').hidden = true; }
      focusPane(btn.dataset.change === 'ring' ? 1 : 2);
    };
  });

  /* photo-honesty captions per metal (persona QA 2026-08-19: platinum shows
     white-gold photos; 14k and 18k share the same photos at different prices).
     A note that just turned visible can sit below the fold on short viewports
     (iPad landscape): nudge it into view without yanking the page. */
  function metalPhotoNote(el, metalName) {
    const wasHidden = el.hidden;
    if (metalName === 'Platinum') {
      el.textContent = 'Platinum, shown in white metal photos: in person it has the same bright white look.';
      el.hidden = false;
    } else if (/^18k/.test(metalName)) {
      el.textContent = '14k and 18k photograph alike; in person the difference is a subtly richer tone.';
      el.hidden = false;
    } else {
      el.hidden = true;
    }
    if (wasHidden && !el.hidden) nudgeIntoView(el);
  }
  function nudgeIntoView(el) {
    try {
      const r = el.getBoundingClientRect();
      if (r.bottom > window.innerHeight || r.top < 0) el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    } catch (e) {}
  }

  /* ---------- render ---------- */
  function render() {
    // A mixed-metal or limited-carat ring must resolve to a real offered variant.
    if (st.ring && !ringVariant()) {
      const first = st.ring.variants.find(v => v.carat === st.carat) || st.ring.variants.find(v => v.carat === firstCarat(st.ring)) || st.ring.variants[0];
      st.carat = first.carat; st.ringMetal = METALS.find(m => m[0] === first.metal);
    }
    if (st.band && !bandVariant()) {
      const first = st.band.variants.find(v => v.metal === '14k Yellow Gold' && st.ringMetal[2] === 'yellow') || st.band.variants[0];
      st.bandMetal = BAND_METALS.find(m => m[0] === first.metal);
    }
    if (st.ring) {
      const base = (c) => { const v = st.ring.variants.find((x) => x.carat === c && x.metal === st.ringMetal[0]); return v ? v.price : null; };
      chips($('[data-carat-chips]'), CARATS.filter(base).map((c) => [c, base(c)]), 'carat',
        (it) => { st.carat = it[0]; }, CARATS.filter(base).indexOf(st.carat));
      const ringMetals = METALS.filter(m => st.ring.variants.some(v => v.carat === st.carat && v.metal === m[0]));
      chips($('[data-ring-metal-chips]'), ringMetals.map((m) => {
        const v = st.ring.variants.find((x) => x.carat === st.carat && x.metal === m[0]);
        return [m[0], v ? v.price : 0, m];
      }), 'metal', (it) => { st.ringMetal = it[2]; if (!st.bandMetalTouched) st.bandMetal = it[2]; if (st.metalView !== it[2][2]) { st.metalView = it[2][2]; syncMetalToggles(); } }, ringMetals.indexOf(st.ringMetal));
      chips($('[data-ring-size-chips]'), SIZES, 'size', (s) => { st.ringSize = s; if (!st.bandSizeTouched) st.bandSize = s; }, SIZES.indexOf(st.ringSize));
      const rpn = $('[data-ring-platinum-note]'); if (rpn) metalPhotoNote(rpn, st.ringMetal[0]);
      if (rpn && st.ring.sourceKey) { rpn.hidden = false; rpn.textContent = photoDescription(sourcePhoto(st.ring, st.ringMetal, st.carat)); }
      const rh = $('[data-ring-hero]'); if (rh) rh.src = caratArt('ring', 640) || imgFor(st.ring, st.ringMetal, 'hero');
      buildGallery('ring');
      $('[data-ring-name]').textContent = st.ring.name;
      /* carry the CONFIGURED variant to the PDP: a bare product URL opened at
         the default price, contradicting the configured one (persona QA
         2026-08-19, Miguel's number-mismatch trap) */
      const rdv = ringVariant();
      $('[data-ring-detail]').href = st.ring.url + (rdv ? '?variant=' + rdv.id : '');
      const rp = ringPrice();
      $('[data-ring-price]').innerHTML = rp ? priceHTML(rp, ringCompare()) + ' · the complete ring' : '';
      $('[data-ring-hint]').textContent = st.ringSize ? '' : 'Choose the ring size to continue: the one thing we need before it is made.';
      $('[data-to-band]').disabled = !ringDone();
      $$('[data-ring-grid] .bsb-tile img').forEach((im) => {
        const product = byHandle(DATA.rings, im.closest('[data-product-handle]').dataset.productHandle);
        if (product) {
          setThumb(im, imgFor(product, viewMetal(), 'thumb'));
          const caption = im.closest('.bsb-tile').querySelector('.bsb-source-caption');
          if (caption) caption.textContent = photoDescription(sourcePhoto(product, viewMetal()));
        }
      });
    }
    if (st.band) {
      const bandMetals = BAND_METALS.filter(m => st.band.variants.some(v => v.metal === m[0]));
      chips($('[data-band-metal-chips]'), bandMetals.map((m) => {
        const v = st.band.variants.find((x) => x.metal === m[0]);
        return [m[0], v ? v.price : 0, m];
      /* a BAND metal pick must not re-aim the shared grid view: persona QA
         2026-08-19 (Priya) proved the chain band-Platinum -> view flips white
         -> Change ring -> tile click preset silently rewrote an explicit 18k
         Yellow ring. Only ring picks and the toggle itself move the view. */
      }), 'metal', (it) => { st.bandMetal = it[2]; st.bandMetalTouched = true; }, bandMetals.indexOf(st.bandMetal));
      chips($('[data-band-size-chips]'), SIZES, 'size', (s) => { st.bandSize = s; st.bandSizeTouched = true; }, SIZES.indexOf(st.bandSize));
      const bpn = $('[data-band-platinum-note]'); if (bpn) metalPhotoNote(bpn, st.bandMetal[0]);
      const bh = $('[data-band-hero]'); if (bh) bh.src = imgFor(st.band, st.bandMetal, 'hero');
      buildGallery('band');
      $('[data-band-name]').textContent = st.band.name;
      const bdv = bandVariant();
      $('[data-band-detail]').href = st.band.url + (bdv ? '?variant=' + bdv.id : '');
      const bp = bandPrice();
      $('[data-band-price]').innerHTML = bp ? priceHTML(bp, bandCompare()) + ' · the complete band' : '';
      $('[data-to-review]').disabled = !bandDone();
      const mismatch = st.ring && st.bandMetal[0] !== st.ringMetal[0];
      const mNote = $('[data-metal-note]');
      const mWasHidden = mNote.hidden;
      mNote.hidden = !mismatch;
      if (mWasHidden && mismatch) nudgeIntoView(mNote);
      /* size twin of the metal guard (persona QA 2026-08-19: a share-link
         recipient's ring-size edit left the band at the old size silently) */
      const sizeNote = $('[data-size-note]');
      if (sizeNote) {
        const wasHidden = sizeNote.hidden;
        sizeNote.hidden = !(st.ringSize && st.bandSize && st.ringSize !== st.bandSize);
        if (wasHidden && !sizeNote.hidden) nudgeIntoView(sizeNote);
      }
      $$('[data-band-grid] .bsb-tile img').forEach((im) => {
        const h = im.closest('.bsb-tile').querySelector('.bsb-tn').textContent;
        const p = DATA.bands.find((x) => x.name === h);
        if (p) { const wanted = viewMetal(); const offered = p.variants.some(v => v.metal === wanted[0]) ? wanted : (BAND_METALS.find(m => m[0] === p.variants[0]?.metal) || wanted); setThumb(im, imgFor(p, offered, 'thumb')); }
      });
    }
    /* tray */
    const tRing = $('[data-tray-ring]'), tBand = $('[data-tray-band]');
    if (st.ring) {
      withCaratArt('ring', tRing.querySelector('img'), 300);
      tRing.querySelector('img').hidden = false; tRing.querySelector('.bsb-tray-empty').hidden = true;
      /* size before metal: when narrow widths must truncate, the metal is
         visible in the thumb + config, the size is not (persona QA 2026-08-19) */
      tRing.querySelector('[data-tray-txt]').textContent = st.ring.name + ' · ' + st.carat + 'ct' + (st.ringSize ? ' · size ' + st.ringSize : '') + ' · ' + st.ringMetal[0];
    }
    if (st.band) {
      withCaratArt('band', tBand.querySelector('img'), 300);
      tBand.querySelector('img').hidden = false; tBand.querySelector('.bsb-tray-empty').hidden = true;
      tBand.querySelector('[data-tray-txt]').textContent = st.band.name + (st.bandSize ? ' · size ' + st.bandSize : '') + ' · ' + st.bandMetal[0];
    }
    const total = (ringPrice() || 0) + (bandPrice() || 0);
    const trayMsrp = (st.ring ? (ringCompare() || ringPrice() || 0) : 0) + (st.band ? (bandCompare() || bandPrice() || 0) : 0);
    $('[data-tray-total]').innerHTML = total ? (trayMsrp > total ? '<s class="bsb__msrp">' + money(trayMsrp) + '</s>' : '') + money(total) : '';
    const tl = $('[data-tray-label]');
    if (tl) {
      tl.hidden = !total;
      /* stage-aware label (persona QA 2026-08-19: "Set total" over a lone ring
         price read as the whole set costing that much) */
      const rp = ringPrice(), bp = bandPrice();
      tl.textContent = rp && bp ? 'Set total' : rp ? 'Ring so far' : 'Band so far';
    }
    const fwd = $('[data-tray-next]');
    if (!ringDone()) { fwd.hidden = true; }
    else if ($('.bsb-pane.is-on') === $('[data-pane-1]') && ringDone()) { fwd.hidden = false; fwd.textContent = 'Choose the band'; fwd.onclick = () => go(2); }
    else if ($('.bsb-pane.is-on') === $('[data-pane-2]') && bandDone()) { fwd.hidden = false; fwd.textContent = 'See the set'; fwd.onclick = () => go(3); }
    else fwd.hidden = true;
    syncSteps();
  }
  function revealConfiguration(target) {
    if (!target) return;
    // Wait for the newly active pane and prices to finish their layout.
    requestAnimationFrame(() => {
      if (!target.isConnected || !target.getClientRects().length) return;
      target.focus({ preventScroll: true });
      const header = document.querySelector('#header-component');
      const headerBox = header?.getBoundingClientRect();
      const offset = (headerBox ? Math.max(0, headerBox.bottom, headerBox.height) : 0) + 16;
      const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
      window.scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    });
  }
  function focusPane(n) {
    const vis = (el) => el && el.getBoundingClientRect().height > 0;
    let target = null;
    if (n === 1) target = vis($('[data-ring-choose]')) ? $('[data-ring-choose] .bsb__h2') : $('[data-ring-name]');
    else if (n === 2) target = vis($('[data-band-choose]')) ? $('[data-band-choose] .bsb__h2') : $('[data-band-name]');
    else target = $('[data-set-title]');
    revealConfiguration(target);
  }

  function syncSteps() {
    const steps = $$('.bsb-step');
    steps[1].disabled = !ringDone();
    steps[2].disabled = !(ringDone() && bandDone());
  }

  /* ---------- review + add ---------- */
  function review() {
    $('[data-set-title]').textContent = st.ring.name + ' and ' + st.band.name;
    withCaratArt('ring', $('[data-rv-ring-img]'), 640);
    withCaratArt('band', $('[data-rv-band-img]'), 640);
    $('[data-rv-ring-name]').textContent = st.ring.name;
    $('[data-rv-ring-spec]').textContent = st.carat + 'ct · ' + st.ringMetal[0] + ' · size ' + st.ringSize;
    if (st.ring.sourceKey) $('[data-rv-ring-spec]').textContent += '. ' + photoDescription(sourcePhoto(st.ring, st.ringMetal, st.carat));
    $('[data-rv-ring-price]').innerHTML = priceHTML(ringPrice(), ringCompare());
    $('[data-rv-band-name]').textContent = st.band.name;
    $('[data-rv-band-spec]').textContent = st.bandMetal[0] + ' · size ' + st.bandSize;
    $('[data-rv-band-price]').innerHTML = priceHTML(bandPrice(), bandCompare());
    $('[data-t-ring]').innerHTML = priceHTML(ringPrice(), ringCompare());
    $('[data-t-band]').innerHTML = priceHTML(bandPrice(), bandCompare());
    const saleTotal = ringPrice() + bandPrice();
    const msrpTotal = (ringCompare() || ringPrice()) + (bandCompare() || bandPrice());
    $('[data-t-total]').innerHTML = priceHTML(saleTotal, msrpTotal > saleTotal ? msrpTotal : null);
    const rvSize = $('[data-rv-size-note]');
    if (rvSize) {
      const diff = st.ringSize && st.bandSize && st.ringSize !== st.bandSize;
      rvSize.hidden = !diff;
      if (diff) rvSize.textContent = 'The ring is size ' + st.ringSize + ' and the band is size ' + st.bandSize + '. On purpose? Just checking.';
    }
    const refOn = partnerCodeActive();
    const newBand = Boolean(st.band?.researchId);
    $('[data-existing-band-timing]').hidden = newBand;
    $('[data-new-band-timing]').hidden = !newBand;
    $('[data-amb-note]').hidden = !refOn || newBand;
    $('[data-new-band-amb-note]').hidden = !refOn || !newBand;
    const share = location.origin + location.pathname + '?' + shareParams();
    $('[data-share-input]').value = share;
  }
  let copyTimer = null;
  $('[data-share-copy]').onclick = () => {
    const inp = $('[data-share-input]');
    const btn = $('[data-share-copy]');
    const status = $('[data-share-status]');
    inp.select();
    /* the receipt shows on the pressed button itself for about 2 seconds; when the browser refuses
       every copy route, a plain line says so and the link stays selected for a manual copy */
    const legacy = () => { try { return !!document.execCommand('copy'); } catch (e) { return false; } };
    const done = (ok) => {
      clearTimeout(copyTimer);
      if (ok) {
        btn.textContent = 'Link copied'; btn.classList.add('is-copied');
        status.textContent = 'Link copied'; status.classList.add('is-sr');
        track('set_builder_shared');
      } else {
        btn.textContent = 'Copy link'; btn.classList.remove('is-copied');
        status.textContent = 'This browser would not copy it. The link above is selected, so you can copy it by hand.';
        status.classList.remove('is-sr');
        try { inp.select(); } catch (e) {}
      }
      try { btn.focus({ preventScroll: true }); } catch (e) {} /* select() parked focus in the input */
      copyTimer = setTimeout(() => {
        btn.textContent = 'Copy link'; btn.classList.remove('is-copied');
        status.textContent = ''; status.classList.remove('is-sr');
      }, ok ? 2000 : 6000);
    };
    /* clipboard API rejects ASYNC where permission is missing (Safari, embedded
       webviews): fall back to the selection copy, and report what really happened */
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(inp.value).then(() => done(true), () => done(legacy()));
      else done(legacy());
    } catch (e) { done(legacy()); }
  };
  $('[data-atc]').onclick = async () => {
    const rv = ringVariant(), bv = bandVariant();
    if (!rv || !bv) return;
    const btn = $('[data-atc]');
    btn.disabled = true; btn.textContent = 'Adding your set';
    /* property KEY "Set" already renders as the label in cart/checkout; a
       prefixed value printed "Set: Set: ..." (persona QA 2026-08-19) */
    const setName = st.ring.name + ' + ' + st.band.name;
    const ringProperties = { 'Ring Size': st.ringSize, 'Set': setName };
    const photo = sourcePhoto(st.ring, st.ringMetal, st.carat);
    if (photo && !photo.matched) ringProperties['Reference photo'] = photo.carat + 'ct in ' + photo.metal;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            { id: rv.id, quantity: 1, properties: ringProperties },
            { id: bv.id, quantity: 1, properties: { 'Ring Size': st.bandSize, 'Set': setName } },
          ],
        }),
      });
      if (!res.ok) throw new Error('add failed ' + res.status);
      track('set_builder_add_to_cart', { ring: st.ring.handle, band: st.band.handle, value: (ringPrice() + bandPrice()) });
      window.location.href = '/cart';
    } catch (e) {
      btn.disabled = false; btn.textContent = 'Add the set to the bag';
      const err = $('[data-atc-error]');
      err.hidden = false;
      /* give the promised escape route real links (persona QA 2026-08-19:
         old copy pointed at links that were not on this screen) */
      err.textContent = 'That did not go through. Please try again, or order ';
      const rl = document.createElement('a'); rl.href = st.ring.url; rl.target = '_blank'; rl.rel = 'noopener'; rl.textContent = 'the ring';
      const bl = document.createElement('a'); bl.href = st.band.url; bl.target = '_blank'; bl.rel = 'noopener'; bl.textContent = 'the band';
      err.appendChild(rl); err.appendChild(document.createTextNode(' and '));
      err.appendChild(bl); err.appendChild(document.createTextNode(' from their own pages.'));
    }
  };

  /* ---------- boot ---------- */
  const params = Object.fromEntries(new URLSearchParams(location.search));
  const fromLink = !!(params.ring || params.band);
  let restored = false;
  if (fromLink) restored = applyState(params, true);
  st.metalView = st.ringMetal[2] === 'yellow' ? 'yellow' : 'white'; /* share links in yellow open the grid in yellow */
  metalToggles();
  sortControls();
  ringGrid();
  save();
  if (st.ring) { $('[data-ring-choose]').hidden = true; $('[data-ring-configure]').hidden = false; }
  if (st.band) { $('[data-band-choose]').hidden = true; $('[data-band-configure]').hidden = false; }
  render();
  if (fromLink && ringDone() && bandDone()) go(3, true);
  else if (fromLink && params.band && !params.ring) { /* band-first entry: ask for the ring */ go(1, true); }
  else if (fromLink && ringDone()) go(2, true);
  /* seed the history base with whatever step we landed on, so the first
     Back after an in-page step change pops to a real state */
  try {
    const landed = $$('.bsb-pane').findIndex((pane) => pane.classList.contains('is-on')) + 1;
    history.replaceState({ bsbStep: landed || 1 }, '', location.href);
  } catch (e) {}
  track('set_builder_open', { restored });
})();
